<template>
  <v-card class="h-100" variant="outlined" color="primary">
    <v-card-title> {{ $t("labels.kpi-formula") }}</v-card-title>
    <v-card-text>
      <div id="mathfield" ref="mathfield"></div>
      <p v-if="!isFormulaValid" class="text-caption mt-2">
        <span class="bg-secondary pa-1 rounded">
          {{ $t("strings.no-measure-formula") }}
        </span>
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import { MathfieldElement } from "mathlive";

export default {
  name: "MathField",
  props: ["formula", "isFormulaValid", "scheduleValue", "scheduleTime"],
  emits: ["update:expression"],
  data() {
    return {
      mathfield: null,
      // expression: this.reverseValues(this.formula?.expression),
    };
  },
  mounted() {
    // Ensure the library is correctly imported and MathfieldElement is available
    if (typeof MathfieldElement !== "undefined") {
      // Create a new instance of the MathfieldElement
      this.mathfield = document.createElement("math-field");
      MathfieldElement.soundsDirectory = null;
      MathfieldElement.fontsDirectory = null;

      // Configure the math field
      this.mathfield.value = this.expression;
      this.mathfield.readonly = true;

      // Append the math field to the DOM
      this.$refs.mathfield.appendChild(this.mathfield);
    } else {
      console.error(
        "MathfieldElement is not defined. Please check your imports.",
      );
    }
  },
  beforeUnmount() {
    if (this.mathfield && this.$refs.mathfield.contains(this.mathfield)) {
      this.$refs.mathfield.removeChild(this.mathfield);
    }
  },
  watch: {
    formula() {
      if (this.mathfield && this.expression !== this.mathfield.value) {
        this.mathfield.value = this.expression;
      }
    },
  },
  computed: {
    expression() {
      return this.reverseValues(this.formula?.expression || "");
    },
  },
  methods: {
    //reverse the formula to be displayed in the editor
    reverseValues(formula) {
      if (!formula || typeof formula !== "string") return "";

      const replacements = {
        "\\mu": "\\avg",
        Σ: "\\sum",
        "\\med": "\\median",
        Mo: "\\mode",
        "\\sigma": "\\stddev",

        // Add more replacements as needed
      };
      let resultString = formula;

      for (const [key, value] of Object.entries(replacements)) {
        resultString = resultString.split(value).join(key);
      }
      return resultString;
    },
  },
};
</script>

<style scoped>
#mathfield :deep(math-field) {
  width: 100%;
  position: relative;
  font-size: 24px;
  border: 0px solid transparent;
  z-index: 1;
  padding: 8px;
}
@media not (pointer: coarse) {
  math-field::part(virtual-keyboard-toggle) {
    display: none;
  }
  math-field::part(menu-toggle) {
    display: none;
  }
}
</style>
